import { useAuth } from "../contexts/AuthContext";

export function LangSwitch() {
  const { lang, setLang } = useAuth();
  return (
    <div className="flex items-center gap-0.5 bg-white/15 rounded-full text-[10px] font-semibold p-0.5 ml-2">
      <button
        onClick={() => setLang("ru")}
        className={`px-2 py-1 rounded-full transition ${lang === "ru" ? "bg-white text-teal-700" : "text-white/80 hover:text-white"}`}
      >RU</button>
      <button
        onClick={() => setLang("uk")}
        className={`px-2 py-1 rounded-full transition ${lang === "uk" ? "bg-white text-teal-700" : "text-white/80 hover:text-white"}`}
      >UK</button>
    </div>
  );
}
